import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import {List, ListItem, Text, VStack} from '@chakra-ui/react'
import Link from '../../../components/link'
import CustomerServiceLayoutDefault from '../layout/default'
import CSHeader from '../partials/header'
import useCustomerServicePageConfig from '../hooks/use-page-config'

const CustomerServiceUserGuidesBrandPage = ({brand}) => {
    const {name, description} = useCustomerServicePageConfig()

    const children = useMemo(
        () => (
            <VStack spacing={4}>
                {brand.products.map((product, idx) => (
                    <VStack
                        align="start"
                        key={idx}
                        gap={6}
                        backgroundColor="stokkeCore.white"
                        w={{
                            base: '100%',
                            md: '46rem',
                            lg: '49rem',
                            xl: '100%',
                            '2xl': '96rem'
                        }}
                        py={{base: 8, lg: 10}}
                        px={{base: 4, lg: '5.25rem', '2xl': '16rem'}}
                    >
                        <Text as="h2" textStyle="Regular 2XLarge">
                            {product.name}
                        </Text>
                        <List spacing={3} listStyleType="disc" ml={6}>
                            {product.documents.map((document, idx) => (
                                <ListItem key={idx}>
                                    <Link to={document.link} isExternal width="100%">
                                        {document.name}
                                    </Link>
                                </ListItem>
                            ))}
                        </List>
                    </VStack>
                ))}
            </VStack>
        ),
        [brand]
    )

    return (
        <CustomerServiceLayoutDefault maxWidth={'100%'} px={{base: 4, lg: '6.5rem', xl: 0}} pb={10}>
            <CSHeader headline={name} subline={description} />
            {children}
        </CustomerServiceLayoutDefault>
    )
}

CustomerServiceUserGuidesBrandPage.propTypes = {
    brand: PropTypes.object
}

export default CustomerServiceUserGuidesBrandPage
